<template>
  <div>
    <SkeletonLoaderTitleUpdate v-show="showSkeleton" />

    <div class="ma-4" v-show="!showSkeleton">
      <div class="text-h4 mb-4">Atualizar Grupo de Captura - {{ description }}</div>
    </div>
    <div v-if="canRender">
      <CadastroGrupoCaptura edicao="true" :_id="_id" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'
import SkeletonLoaderTitleUpdate from '@/componentes/SkeletonLoaderTitleUpdate'

import gruposCapturaStore from '../_store'

import CadastroGrupoCaptura from './CadastroGrupoCaptura'

export default {
  name: 'AtualizarGrupoCaptura',
  props: {
    _id: String,
  },
  components: { CadastroGrupoCaptura, SkeletonLoaderTitleUpdate },

  data: () => ({
    description: '',
    showSkeleton: false,
    canRender: false,
  }),

  computed: {
    ...mapGetters('atualizarGrupoCapturaModulePABXStore', ['getGrupoCapturaSelecionado']),
  },

  async created() {
    this.showSkeleton = true

    registerVuexModule(this.$store, 'atualizarGrupoCapturaModulePABXStore', gruposCapturaStore)

    await this.listarGrupoCapturaSelecionado(this._id)
    this.description = this.getGrupoCapturaSelecionado.description

    this.showSkeleton = false
    this.canRender = true
  },

  methods: {
    ...mapActions('atualizarGrupoCapturaModulePABXStore', ['listarGrupoCapturaSelecionado']),
  },
}
</script>
